import { render, staticRenderFns } from "./AdvanceInfo.vue?vue&type=template&id=51ce66d6&"
import script from "./AdvanceInfo.vue?vue&type=script&lang=js&"
export * from "./AdvanceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\laravel\\rawal\\rawal-laravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51ce66d6')) {
      api.createRecord('51ce66d6', component.options)
    } else {
      api.reload('51ce66d6', component.options)
    }
    module.hot.accept("./AdvanceInfo.vue?vue&type=template&id=51ce66d6&", function () {
      api.rerender('51ce66d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/product/AdvanceInfo.vue"
export default component.exports